<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <ng-select
        [items]="rateCategories$ | async"
        [clearable]="false"
        bindLabel="name"
        bindValue="id"
        [multiple]="false"
        formControlName="rateCategory"
        placeholder="Rate Category (optional)"
        class="mat-block"
      >
      </ng-select>
    </div>
    <div class="col-md-3 offset-3">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Base Charge (' + currencySymbol + '):'"></span></mat-label>
        <input matInput type="number" min="0" formControlName="charge" (keyup)="onChargeChange($event.target.value)" />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-9"></div>
    <div class="col-md-3">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Extra Guest Fee (' + currencySymbol + '):'"></span></mat-label>
        <input type="number" [value]="cost?.extraGuests || 0" matInput disabled />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h6>Discounts &amp; Fees</h6>
    </div>
  </div>
  <div class="row" *ngFor="let item of cost?.auditDiscounts">
    <div class="col-md-8 discount-controls">
      <button (click)="onViewDiscount(item)" class="add-discount discount-btn" type="button">
        <i class="fal fa-eye text-black-50"></i>
      </button>
      <span class="discount-msg">{{ item.disc_type === 'lengthofstay' ? 'LOS Discount' : 'Discount Code' }}</span>
    </div>
    <div class="col-md-4 pl-0">
      <mat-form-field class="mat-block">
        <mat-label><span [innerHtml]="'Amount (' + currencySymbol + '):'"></span></mat-label>
        <input type="number" [value]="item.disc_amount" matInput disabled />
      </mat-form-field>
    </div>
  </div>
  <div formArrayName="discounts" *ngFor="let item of discounts.controls; let i = index" class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-9 discount-controls">
          <button (click)="removeDiscountsOrFees(i)" class="remove-discount discount-btn" type="button">
            <i class="fal fa-minus"></i>
          </button>
          <span class="discount-msg" *ngIf="item.value.amount > 0">Added to the base charge:</span>
          <span class="discount-msg" *ngIf="item.value.amount < 0">Subtracted from the base charge:</span>
          <span class="discount-msg" *ngIf="!item.value.amount">Discount or fee:</span>
        </div>
        <div [formGroupName]="i" class="col-md-3 discount-holder">
          <mat-form-field class="mat-block">
            <mat-label><span [innerHtml]="'Amount (' + currencySymbol + '):'"></span></mat-label>
            <input type="number" (input)="updateEngineCost()" formControlName="amount" matInput />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3" *ngIf="discounts.length < discountsOrFeesLimit">
    <div class="col-md-9 discount-controls">
      <button (click)="addDiscountsOrFees()" class="add-discount discount-btn" type="button">
        <i class="fal fa-plus"></i>
      </button>
      <a (click)="addDiscountsOrFees()" href="javascript:;"> Add Discount/Fee </a>
    </div>
  </div>
  <div *ngIf="fees.controls?.length > 0" class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <h6>Booking Fees</h6>
        </div>
      </div>
      <div formArrayName="fees" *ngFor="let item of fees.controls; let i = index">
        <div class="row" [formGroupName]="i">
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input type="text" formControlName="name" matInput placeholder="Fee Name:" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input type="number" min="0" formControlName="rate" matInput placeholder="Fee Rate:" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <mat-select formControlName="modality" placeholder="Modality">
                <mat-option [value]="feeModalities.PerStay">{{ feeModalityLabels[feeModalities.PerStay] }}</mat-option>
                <mat-option [value]="feeModalities.PerNight">{{
                  feeModalityLabels[feeModalities.PerNight]
                }}</mat-option>
                <mat-option [value]="feeModalities.PerPerson">{{
                  feeModalityLabels[feeModalities.PerPerson]
                }}</mat-option>
                <mat-option [value]="feeModalities.PerPersonPerNight">{{
                  feeModalityLabels[feeModalities.PerPersonPerNight]
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <mat-label><span [innerHtml]="'Fee Amount (' + currencySymbol + '):'"></span></mat-label>
              <input type="number" min="0" formControlName="amount" matInput />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="taxes.controls?.length > 0" class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <h6>Taxes</h6>
        </div>
      </div>
      <div formArrayName="taxes" *ngFor="let item of taxes.controls; let i = index">
        <div class="row" [formGroupName]="i">
          <div class="col-md-6">
            <mat-form-field class="mat-block">
              <input type="text" formControlName="taxName" matInput placeholder="Tax Name:" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <input type="number" min="0" formControlName="taxRate" matInput placeholder="Tax Rate:" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field class="mat-block">
              <mat-label><span [innerHtml]="'Tax Amount (' + currencySymbol + '):'"></span></mat-label>
              <input type="number" min="0" formControlName="taxAmount" matInput />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="offset-md-8 col-md-4">
      <h6>
        Total:
        <span [innerHtml]="(cost || inquiry.bookingEngine)?.total | tokeetCurrency: inquiry?.rental?.currency"></span>
      </h6>
    </div>
  </div>
</form>

<div class="footer-control">
  <button
    [disabled]="loading"
    (click)="close.emit(true)"
    type="button"
    class="btn btn-outline btn-default-outline text-uppercase"
  >
    <i class="fal fa-times"></i> cancel
  </button>
  <button [disabled]="loading" (click)="reset()" type="button" class="btn btn-cst-info text-uppercase">
    <i class="fal fa-sync-alt"></i> reset
  </button>
  <button *ngIf="!loading" (click)="save(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-save"></i> save
  </button>
  <button
    *ngIf="loading"
    matTooltip="Calculating cost..."
    matTooltipPosition="above"
    matTooltipClass="text-center"
    type="button"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
</div>
